type SiteConfig = {
  name: string;
  description: string;
  domain: string;
};

export const siteConfig: SiteConfig = {
  name: "TMG",
  description: "The Mansa Group",
  domain: "https://mansagrp.com",
};
